/**
 * LocalNotificationService — rest timer, workout reminders.
 * No-op on web.
 */
import { isNative } from '../utils/platform';

function getPlugin() {
  return window.Capacitor?.Plugins?.LocalNotifications || null;
}

const ID_REST_TIMER = 1001;
const ID_WORKOUT_REMINDER = 1002;

export class LocalNotificationService {
  static async requestPermission() {
    const p = getPlugin();
    if (!p) return true;
    const result = await p.requestPermissions();
    return result.display === 'granted';
  }

  static async scheduleRestEnd(restSeconds, exerciseName) {
    const p = getPlugin();
    if (!p) return;
    await this.cancelRestTimer();
    await p.schedule({
      notifications: [{
        id: ID_REST_TIMER,
        title: 'Odpoczynek zakończony',
        body: exerciseName ? `Czas na kolejną serię: ${exerciseName}` : 'Czas na kolejną serię!',
        schedule: { at: new Date(Date.now() + restSeconds * 1000) },
        sound: 'beep.wav',
        autoCancel: true,
      }],
    });
  }

  static async cancelRestTimer() {
    const p = getPlugin();
    if (!p) return;
    try { await p.cancel({ notifications: [{ id: ID_REST_TIMER }] }); } catch {}
  }

  static async scheduleWorkoutReminder(sessionDate, trainerName, bookingId) {
    const p = getPlugin();
    if (!p) return;
    const at = new Date(sessionDate.getTime() - 60 * 60 * 1000);
    if (at <= new Date()) return;
    await p.schedule({
      notifications: [{
        id: ID_WORKOUT_REMINDER,
        title: 'Trening za godzinę',
        body: `Twój trening z ${trainerName} zaczyna się za godzinę.`,
        schedule: { at },
        autoCancel: true,
        extra: { type: 'booking_reminder', bookingId },
      }],
    });
  }

  static async cancelAll() {
    const p = getPlugin();
    if (!p) return;
    const { notifications } = await p.getPending();
    if (notifications.length > 0) await p.cancel({ notifications });
  }
}
